import {ErrorCode} from '@sollapay/enums';

export interface RawInitiatePaymentError {
  code?: string;
  message: string;
}

interface Matcher {
  code?: string;
  message?: string;
  messagePrefix?: string;
  reasonCode: ErrorCode;
}

const MATCHERS: Matcher[] = [
  {code: 'PROVIDER_UNAVAILABLE', reasonCode: ErrorCode.PAY_PROVIDER_UNAVAILABLE},
  {message: 'PROVIDER_ERROR', reasonCode: ErrorCode.PAY_PROVIDER_ERROR},
  {
    message: 'An unexpected server error has occurred',
    reasonCode: ErrorCode.PAY_UNEXPECTED_SERVER_ERROR
  },
  {message: 'This branch is not supported anymore', reasonCode: ErrorCode.PAY_BRANCH_NOT_SUPPORTED},
  {message: 'psuId is invalid', reasonCode: ErrorCode.PAY_INVALID_PSU_ID},
  {message: 'Invalid token', reasonCode: ErrorCode.PAY_INVALID_OF_TOKEN},
  {
    message: 'Needs to provide paymentId or new payment info',
    reasonCode: ErrorCode.PAY_MISSING_PAYMENT_INFO
  },
  {message: 'Invalid provider', reasonCode: ErrorCode.PAY_INVALID_PROVIDER},
  {message: 'Missing debtor or credit info', reasonCode: ErrorCode.PAY_MISSING_ACCOUNT_INFO},
  {
    message: 'Redirect url is not in allowed url list',
    reasonCode: ErrorCode.PAY_REDIRECT_URL_NOT_ALLOWED
  },
  {
    message: 'Creditor and debtor accounts are the same',
    reasonCode: ErrorCode.PAY_ACCOUNTS_MATCH_ERROR
  },
  {
    message: 'The provider does not match the payment settings',
    reasonCode: ErrorCode.PAY_PROVIDER_MISMATCH
  },
  {
    message: 'Merchant Id or creditor info is required',
    reasonCode: ErrorCode.PAY_MERCHANT_INFO_REQUIRED
  },
  {
    message: 'Payment information description is missing',
    reasonCode: ErrorCode.PAY_DESCRIPTION_MISSING
  },
  {
    message: 'Debtor account is not a sandbox account',
    reasonCode: ErrorCode.PAY_SANDBOX_ACCOUNT_REQUIRED
  },
  {message: 'provider not found', reasonCode: ErrorCode.PAY_PROVIDER_NOT_FOUND},
  {message: 'Merchant not found', reasonCode: ErrorCode.PAY_MERCHANT_NOT_FOUND},
  {message: 'Merchant not found in db', reasonCode: ErrorCode.PAY_MERCHANT_NOT_FOUND},
  {
    message: 'Creditor account is not allowed for this organization',
    reasonCode: ErrorCode.PAY_CREDITOR_ACCOUNT_NOT_ALLOWED
  },
  {
    message: 'Provider is not allowed for this payment',
    reasonCode: ErrorCode.PAY_PROVIDER_NOT_ALLOWED
  },
  {message: 'Unauthorized', reasonCode: ErrorCode.PAY_OF_UNAUTHORIZED},
  {message: 'Org Id is not in token', reasonCode: ErrorCode.PAY_ORG_ID_MISSING},
  {
    message: 'no org settings found, please reach out to solve this issue',
    reasonCode: ErrorCode.PAY_ORG_SETTINGS_NOT_FOUND
  },
  {messagePrefix: 'Error creating payment:', reasonCode: ErrorCode.PAY_PAYMENT_CREATION_ERROR},
  {messagePrefix: 'Error creating consent:', reasonCode: ErrorCode.PAY_CONSENT_CREATION_ERROR}
];

export function resolveInitiatePaymentFailure(error: RawInitiatePaymentError): ErrorCode | null {
  const match = MATCHERS.find(
    m =>
      (m.code !== undefined && m.code === error.code) ||
      (m.message !== undefined && m.message === error.message) ||
      (m.messagePrefix !== undefined && error.message.startsWith(m.messagePrefix))
  );
  return match?.reasonCode ?? null;
}
